import { useRef } from "react";
import styled from "styled-components";
import { useVisibilityObserver } from "hooks/useVisibilityObserver";

const StyledVisibilityAnimator = styled.div`
  position: ${({ $nonRelative }) => ($nonRelative ? "static" : "relative")};
  z-index: ${({ $zIndex }) => $zIndex};
  width: 100%;
  opacity: 0;
  transform: translateY(18px);
  transition: opacity 520ms ease, transform 520ms ease;

  &.visible {
    opacity: 1;
    transform: none;
  }

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    transform: none;
    transition: none;
  }
`;

export const VisibilityAnimator = ({
  children,
  showInstantly,
  zIndex,
  nonRelative,
}) => {
  const animatorRef = useRef(null);
  const { isVisible } = useVisibilityObserver(animatorRef);

  return (
    <StyledVisibilityAnimator
      ref={animatorRef}
      className={showInstantly || isVisible ? "visible" : undefined}
      $zIndex={zIndex}
      $nonRelative={nonRelative}
    >
      {children}
    </StyledVisibilityAnimator>
  );
};
